<div class="default-layout">
  <navigation-bar />
  <transition
    name="fade-fast"
    mode="out-in"
  >
    <router-view />
  </transition>
</div>